import React, { FC } from 'react';
import { DefaultText } from './DefaultText';

interface ComponentProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const MutedText: FC<ComponentProps> = ({ children, style = {} }) => (
  <DefaultText color={(theme) => theme.palette.text.disabled} style={style}>
    {children}
  </DefaultText>
);
